import { useCallback, useEffect, useState } from "react";
import { api } from "../../../lib/api";
import { useAuth } from "../../../providers/AuthProvider";

export type Product = {
  id: string;
  business_id: string;
  name: string;
  sku: string | null;
  barcode?: string | null;
  barcode_source?: string | null;
  brand_id: string | null;
  status: string | null;
  category_ids: string[];
  is_gst_applicable?: boolean;
  gst_rate?: string | null;
  gst_type?: string | null;
  hsn_code?: string | null;
  available_qty_net?: string | null;
  pos_override_batch_id?: string | null;
  is_override?: boolean;
  pos_active_batch?: {
    id: string;
    received_at: string | null;
    quantity_remaining: string;
    selling_price: string;
    mrp: string;
    purchase_price: string;
  } | null;
  categories?: Array<{ id: string; name: string }> | null;
};

export function useProducts() {
  const { token } = useAuth();
  const [rows, setRows] = useState<Product[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(async () => {
    if (!token) {
      setRows([]);
      setLoading(false);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const res = await api.products.list({ token });
      setRows(res.data);
    } catch (e) {
      setError(e instanceof Error ? e.message : "Failed to load products");
      setRows([]);
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    void reload();
  }, [reload]);

  return { products: rows, loading, error, reload };
}

